/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CheckOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Col, message, Modal, Row, Spin } from 'antd'
import { PaymentElement, useElements } from '@stripe/react-stripe-js'
import React, { PropsWithChildren, useMemo, useState } from 'react'
import { Title } from '../UserDetailForm/UserDetailForm.styles'
import { Card } from './PlanBilling.styles'
import { useAppSelector } from '../../../store/hooks'
import { SUBSCRIPTION } from '../../../utils/consts'
import { ModalButton } from '../../../pages/Project/Project.styles'

interface LooseObject {
    [key: string]: any
}

interface PropsType {
    isLoading: boolean
    subscriptionId: string
    cancelSubscription: () => void
    preSubscription: () => void
}

const { confirm } = Modal

const PlanBilling = ({
    isLoading,
    subscriptionId,
    cancelSubscription,
    preSubscription,
}: PropsWithChildren<PropsType>): JSX.Element => {
    const elements = useElements()

    const user = useAppSelector((state) => state.user!)
    const [selectArr, setSelectArr] = useState<LooseObject>({
        subscribed: false,
        upgrade: false,
        contactSales: false,
    })

    const ColorHandle = (selectedKey: string) => {
        const newSel = { ...selectArr }
        const keyArr = Object.keys(selectArr)
        for (let i = 0; i < keyArr.length; i++) {
            if (keyArr[i] === selectedKey) newSel[keyArr[i]] = true
            else newSel[keyArr[i]] = false
        }
        setSelectArr(newSel)
        if (selectedKey === 'upgrade') {
            if (!soloType) {
                if (subscriptionId.length > 0) {
                    message.warning(
                        'Fill out your payment info and Click the "Finish" button'
                    )
                } else {
                    preSubscription()
                }
            }
            return
        }
        if (selectedKey === 'downgrade') {
            confirm({
                title: 'Do you want to downgrade your subscription?',
                icon: null,
                content: '',
                okType: 'text',
                className: 'upgrade-confirm-wrapper',
                okText: (
                    <ModalButton
                        type="ghost"
                        shape="round"
                        icon={<CheckOutlined />}
                    >
                        Yes
                    </ModalButton>
                ),
                cancelButtonProps: { type: 'text' },
                cancelText: (
                    <ModalButton shape="round" icon={<CloseOutlined />}>
                        No
                    </ModalButton>
                ),
                onOk() {
                    const cardElement = elements?.getElement(PaymentElement)
                    if (cardElement && 'clear' in cardElement) {
                        console.log('clear')
                        cardElement.clear()
                    }
                    cancelSubscription()
                },
            })
        }
    }

    const freeType = useMemo(() => {
        return user.subscription === SUBSCRIPTION.FREE
    }, [user])

    const soloType = useMemo(() => {
        return user.subscription === SUBSCRIPTION.SOLO
    }, [user])

    return (
        <Spin spinning={isLoading}>
            <Row gutter={16}>
                <Col span={24}>
                    <Title>Plan & Billing</Title>
                </Col>
            </Row>
            <Row gutter={8}>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 8 }}
                    lg={{ span: 8 }}
                >
                    <div>
                        <Card
                            style={
                                freeType
                                    ? {
                                          paddingBottom: '5px',
                                          paddingTop: '5px',
                                          marginTop: '-5px',
                                          backgroundColor: '#e2f9e3',
                                          borderColor: '#52d858',
                                      }
                                    : {}
                            }
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    position: 'relative',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <div className="cardName">
                                    <p>Free</p>
                                </div>
                                <div className="cardContent">
                                    <p>
                                        Create your own patent application, but
                                        without the ability to export draft
                                        patent application.
                                    </p>
                                </div>
                                <div className="cardBtn">
                                    {freeType ? (
                                        <Button
                                            icon={<CheckOutlined />}
                                            style={{
                                                backgroundColor: '#c5f2c7',
                                                borderColor: '#52d858',
                                            }}
                                            onClick={() =>
                                                ColorHandle('subscribed')
                                            }
                                        >
                                            Subscribed
                                        </Button>
                                    ) : (
                                        <Button
                                            onClick={() =>
                                                ColorHandle('downgrade')
                                            }
                                        >
                                            Downgrade
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </Card>
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 8 }}
                    lg={{ span: 8 }}
                >
                    <div>
                        <Card
                            style={
                                soloType
                                    ? {
                                          paddingBottom: '5px',
                                          paddingTop: '5px',
                                          marginTop: '-5px',
                                          backgroundColor: '#e2f9e3',
                                          borderColor: '#52d858',
                                      }
                                    : {}
                            }
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    height: '100%',
                                }}
                            >
                                <div>
                                    <div className="cardName">
                                        <p>Solo $99/month</p>
                                    </div>
                                    <div
                                        className="cardContent"
                                        style={{
                                            marginTop: '13px',
                                        }}
                                    >
                                        <p>
                                            Create and export your own patent
                                            applications in Docx format and
                                            drawings in pdf format.
                                        </p>
                                    </div>
                                </div>
                                <div className="cardBtn">
                                    {soloType ? (
                                        <Button
                                            onClick={() =>
                                                ColorHandle('upgrade')
                                            }
                                            icon={<CheckOutlined />}
                                            style={{
                                                backgroundColor: '#c5f2c7',
                                                borderColor: '#52d858',
                                            }}
                                        >
                                            Subscribed
                                        </Button>
                                    ) : (
                                        <Button
                                            onClick={() =>
                                                ColorHandle('upgrade')
                                            }
                                            icon={<PlusOutlined />}
                                        >
                                            Upgrade
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </Card>
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 8 }}
                    lg={{ span: 8 }}
                >
                    <div>
                        <Card
                            style={
                                selectArr.contactSales
                                    ? {
                                          paddingBottom: '5px',
                                          paddingTop: '5px',
                                          marginTop: '-5px',
                                          backgroundColor: '#e2f9e3',
                                          borderColor: '#52d858',
                                      }
                                    : {}
                            }
                        >
                            <div className="card">
                                <div className="cardName">
                                    <p>Assist</p>
                                </div>
                                <div
                                    className="cardContent"
                                    style={{
                                        marginTop: '13px',
                                    }}
                                >
                                    <p>
                                        Same as solo, but we can provide you
                                        with a list of patent attorneys who have
                                        expressed interest in assisting
                                        inventors using this tool.
                                    </p>
                                </div>
                                <div className="cardBtn">
                                    <Button
                                        style={
                                            selectArr.contactSales
                                                ? {
                                                      backgroundColor:
                                                          '#c5f2c7',
                                                      borderColor: '#52d858',
                                                  }
                                                : {}
                                        }
                                        href="mailto:sales@innovationx.ai"
                                    >
                                        Contact Sales
                                    </Button>
                                </div>
                            </div>
                        </Card>
                    </div>
                </Col>
            </Row>
        </Spin>
    )
}

export default PlanBilling
